"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ExportFile = void 0;
var _exportFile = require("./exportFile");
exports.PLUGIN_KEY = _exportFile.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _exportFile.PLUGIN_PRIORITY;
exports.ExportFile = _exportFile.ExportFile;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/exportFile/index.js
// module id = 1355
// module chunks = 0